import * as angular from 'angular';
import { ILocationService, IWindowService } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { PlannedDiplomaType } from '../../../../../../ng2/shared/constants/planned-diploma-type.constant';
import { SdcActionsService } from './../../../../../sdc/flux/sdc-actions.service';
import { ISdcStore } from './../../../../../sdc/flux/sdc-store.interface';
import { SpinnerModal } from './../../../../../shared/modals/status-spinner/status-spinner.service';

export class CohortCtrl {
  static $inject = [
    '$scope',
    '$window',
    '$location',
    'SDCStore',
    'SpinnerModal',
    'ErrorModal',
    'sdcActions',
    'ImSchool',
  ];

  constructor(
    private $scope,
    private $window: IWindowService,
    private $location: ILocationService,
    private SDCStore: ISdcStore,
    private SpinnerModal: SpinnerModal,
    private ErrorModal: any,
    private sdcActions: SdcActionsService,
    private ImSchool: ImSchool,
  ) {}

  public currentCohortMetrics: any;
  public cohortHumanName: string;
  public cohortStudentYear: string;
  public metricLabels: any;
  public getExplanation: any;
  public buttonState: any;
  public getAsOfHumanName: any;
  public showHideExplanation: any;
  public activeExplanation: any;
  public activeExplanationAsOf: any;
  public explanationIcons: any;

  // bindings
  public cohort: any;
  public currentSchool: any;

  $onInit(): void {
    this.explanationIcons = {
      Credits: {
        asOfSept: 'expand_more',
        asOfJan: 'expand_more',
      },
      Advanced: {
        asOfSept: 'expand_more',
        asOfJan: 'expand_more',
      },
      Regents: {
        asOfSept: 'expand_more',
        asOfJan: 'expand_more',
      },
      Local: {
        asOfSept: 'expand_more',
        asOfJan: 'expand_more',
      },
    };

    this.buttonState = {
      isDisabled: false,
    };

    this.metricLabels = {
      credits: 'Credits',
      advanced: PlannedDiplomaType.ADVANCED_REGENTS.humanName,
      regents: PlannedDiplomaType.REGENTS.humanName,
      local: PlannedDiplomaType.LOCAL.humanName,
    };

    // get metrics for currently displayed cohort
    this.currentCohortMetrics = _.find(this.currentSchool.onTrackMetrics.gradPlanningThresholds, (v: any, k) => {
      return k === this.cohort.keyForGradPlanningThresholds;
    });

    // due to TSLINT rules (object access via string literals is disallowed), dynamically assign prop names as vars
    let _key = '_key';
    let _order = '_order';
    this.currentCohortMetrics.asOfSept[_key] = 'asOfSept';
    this.currentCohortMetrics.asOfSept[_order] = 1;
    this.currentCohortMetrics.asOfJan[_key] = 'asOfJan';
    this.currentCohortMetrics.asOfJan[_order] = 2;
    this.currentCohortMetrics = _.sortBy(_.values(this.currentCohortMetrics), '_order');

    this.getAsOfHumanName = asOf => {
      if (asOf === 'asOfSept') return 'September';
      if (asOf === 'asOfJan') return 'January';
    };

    this.cohortHumanName = this.cohort.humanName;

    // Convert studentYear to human readable
    let studentYear = this.cohort.studentYear;
    if (studentYear === 1) {
      this.cohortStudentYear = '1st';
    } else if (studentYear === 2) {
      this.cohortStudentYear = '2nd';
    } else if (studentYear === 3) {
      this.cohortStudentYear = '3rd';
    } else if (studentYear === 4) {
      this.cohortStudentYear = '4th';
    }

    this.getExplanation = asOf => {
      return {
        nonGrad: this.ImSchool.getGradPlanningThresholdsExplainer(
          this.currentSchool,
          this.cohortHumanName,
          asOf,
          PlannedDiplomaType.NON_GRADUATE.humanName,
        ),
        advanced: this.ImSchool.getGradPlanningThresholdsExplainer(
          this.currentSchool,
          this.cohortHumanName,
          asOf,
          PlannedDiplomaType.ADVANCED_REGENTS.humanName,
        ),
        regents: this.ImSchool.getGradPlanningThresholdsExplainer(
          this.currentSchool,
          this.cohortHumanName,
          asOf,
          PlannedDiplomaType.REGENTS.humanName,
        ),
        local: this.ImSchool.getGradPlanningThresholdsExplainer(
          this.currentSchool,
          this.cohortHumanName,
          asOf,
          PlannedDiplomaType.LOCAL.humanName,
        ),
      };
    };

    // TODO - this needs a test
    this.showHideExplanation = (value, asOfValue) => {
      if (value === this.activeExplanation && asOfValue === this.activeExplanationAsOf) {
        this.activeExplanation = null;
        this.activeExplanationAsOf = null;
        this.explanationIcons[value][asOfValue] = 'expand_more';
      } else {
        if (this.activeExplanation && this.activeExplanationAsOf)
          this.explanationIcons[this.activeExplanation][this.activeExplanationAsOf] = 'expand_more';
        this.activeExplanation = value;
        this.activeExplanationAsOf = asOfValue;
        this.explanationIcons[value][asOfValue] = 'expand_less';
      }
    };
  }

  save() {
    this.SpinnerModal.activateSpinner('Updating Students');
    const path = 'onTrackMetrics.gradPlanningThresholds';
    this.currentSchool
      .$patchFields([path], cs => {
        const patchValue = _.get(cs, path);
        const patch = {
          onTrackMetrics: {
            gradPlanningThresholds: angular.copy(patchValue),
          },
        };
        this.sdcActions.updateSchoolByPatch(patch);
        this.SpinnerModal.deactivateSpinner();
        this.currentSchool.trackServerState();
      })
      .catch(errorResponse => {
        this.ErrorModal.show('Unable to save your changes', errorResponse);
      });
  }
}
